export default __webpack_public_path__ + "static/media/Avatar_Profile.e60cf554.png";